import { fetcherPost, fetcherGet } from './fetcher'
import { path, propOr } from 'ramda'
import { ls, noop } from '@iqueue/ui-kit'

export default class Auth {
  static async login({ username, password }) {
    const data = await fetcherPost('v1/auth/login', {
      username,
      password,
    })

    const token = path(['data', 'accessToken'], data)
    ls('amber-auth-token', token)

    return propOr({}, 'data', data)
  }

  static logout() {
    ls('account', null)
    ls('permissions', null)
    ls('amber-auth-token', '')
    fetcherPost('v1/auth/logout', {}).catch(noop)
  }

  static async getMe() {
    return fetcherGet('v1/auth/get-me')
  }
}
